// removed by extract-text-webpack-plugin
module.exports = {"theme":"#45baa3"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/index.scss
// module id = N9P1
// module chunks = 6 7